module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "massage-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("Masáže psů")]), _vm._v(" "), _c('p', [_vm._v("\n          Salon Jája zavedl novou službu pro Vaše psí miláčky, a to regenerační masáže.\n          Ty pomáhají řešit určité zdravotní problémy psa a zlepšují jeho celkový zdravotní stav i tělesnou kondici.\n          Pozitivně působí na tělesné i psychické zdraví psů bez rozdílů věku a fyzického stavu.\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Upozornění:")]), _vm._v(" před masáží 2 hodiny nepodávat stravu")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b', [_vm._v("Masáže se vyznačují následujícími účinky:")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("pomáhají zejména k zlepšení lymfatického a oběhového systému")]), _vm._v(" "), _c('li', [_vm._v("udržují vnitřní rovnováhu celého těla")]), _vm._v(" "), _c('li', [_vm._v("uvolňují svalová spazmata, křeče a srůsty")]), _vm._v(" "), _c('li', [_vm._v("uvolňují působení stresu a symptomů s ním spojených")]), _vm._v(" "), _c('li', [_vm._v("prokrvují kůži, udržují zdravou a zářivou srst")]), _vm._v(" "), _c('li', [_vm._v("rozrušují malé tukové útvary")]), _vm._v(" "), _c('li', [_vm._v("zlepšují elasticitu kůže")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b', [_vm._v("Masáže se však nedoporučují při:")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("onemocnění psa")]), _vm._v(" "), _c('li', [_vm._v("infekci kůže")]), _vm._v(" "), _c('li', [_vm._v("otevřeném zranění")]), _vm._v(" "), _c('li', [_vm._v("dehydrataci  psa")]), _vm._v(" "), _c('li', [_vm._v("extrémním vyčerpání psa")]), _vm._v(" "), _c('li', [_vm._v("otocích a podlitinách")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-353863b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/MassageView.vue
// module id = 74
// module chunks = 0